export async function parseJsonSafely(response) {
    try {
        return await response.json();
    } catch (error) {
        console.error(error);

        return {};
    }
}
